module.exports = __webpack_public_path__ + "img/badesaba-red-logo.c4e1c9db.svg";